import React from 'react';
import { VictoryContainer, VictoryVoronoiContainer } from 'victory';

export const victoryContainerStyle = { touchAction: 'auto' };
export const defaultVictoryContainer = <VictoryContainer responsive={false} style={victoryContainerStyle} />;
export const defaultVictoryVoronoiContainer = <VictoryVoronoiContainer style={victoryContainerStyle} />;
